
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as editfrxLtCWWmHMeta } from "/vercel/path0/pages/[org_slug]/document-forms/[slug]/edit.vue?macro=true";
import { default as indexJI9uMNcosJMeta } from "/vercel/path0/pages/[org_slug]/document-forms/[slug]/fill/[response_uuid]/index.vue?macro=true";
import { default as indexDyJjL35PV5Meta } from "/vercel/path0/pages/[org_slug]/document-forms/[slug]/index.vue?macro=true";
import { default as indexGZprjFvRZoMeta } from "/vercel/path0/pages/[org_slug]/document-forms/[slug]/view/[response_uuid]/index.vue?macro=true";
import { default as createL0e1TkVDdNMeta } from "/vercel/path0/pages/[org_slug]/document-forms/create.vue?macro=true";
import { default as edit0YBnk1vrJGMeta } from "/vercel/path0/pages/[org_slug]/form/[slug]/edit.vue?macro=true";
import { default as indexrqMZ7CYH2xMeta } from "/vercel/path0/pages/[org_slug]/form/[slug]/index.vue?macro=true";
import { default as responseiMuD2AXELcMeta } from "/vercel/path0/pages/[org_slug]/form/[slug]/response.vue?macro=true";
import { default as createXwaw5SfMIHMeta } from "/vercel/path0/pages/[org_slug]/form/create.vue?macro=true";
import { default as observerRS5rgp7aIqMeta } from "/vercel/path0/pages/[org_slug]/form/observer.vue?macro=true";
import { default as indexVG4lrxEhIgMeta } from "/vercel/path0/pages/[org_slug]/index.vue?macro=true";
import { default as editkkvh3iHP9fMeta } from "/vercel/path0/pages/[org_slug]/template/[slug]/edit.vue?macro=true";
import { default as index0faYolGCqdMeta } from "/vercel/path0/pages/[org_slug]/template/[slug]/index.vue?macro=true";
import { default as previewmeU5txUS1KMeta } from "/vercel/path0/pages/[org_slug]/template/[slug]/preview.vue?macro=true";
export default [
  {
    name: "org_slug-document-forms-slug-edit",
    path: "/:org_slug()/document-forms/:slug()/edit",
    meta: editfrxLtCWWmHMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/document-forms/[slug]/edit.vue")
  },
  {
    name: "org_slug-document-forms-slug-fill-response_uuid",
    path: "/:org_slug()/document-forms/:slug()/fill/:response_uuid()",
    meta: indexJI9uMNcosJMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/document-forms/[slug]/fill/[response_uuid]/index.vue")
  },
  {
    name: "org_slug-document-forms-slug",
    path: "/:org_slug()/document-forms/:slug()",
    meta: indexDyJjL35PV5Meta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/document-forms/[slug]/index.vue")
  },
  {
    name: "org_slug-document-forms-slug-view-response_uuid",
    path: "/:org_slug()/document-forms/:slug()/view/:response_uuid()",
    meta: indexGZprjFvRZoMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/document-forms/[slug]/view/[response_uuid]/index.vue")
  },
  {
    name: "org_slug-document-forms-create",
    path: "/:org_slug()/document-forms/create",
    meta: createL0e1TkVDdNMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/document-forms/create.vue")
  },
  {
    name: "org_slug-form-slug-edit",
    path: "/:org_slug()/form/:slug()/edit",
    meta: edit0YBnk1vrJGMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/form/[slug]/edit.vue")
  },
  {
    name: "org_slug-form-slug",
    path: "/:org_slug()/form/:slug()",
    component: () => import("/vercel/path0/pages/[org_slug]/form/[slug]/index.vue")
  },
  {
    name: "org_slug-form-slug-response",
    path: "/:org_slug()/form/:slug()/response",
    meta: responseiMuD2AXELcMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/form/[slug]/response.vue")
  },
  {
    name: "org_slug-form-create",
    path: "/:org_slug()/form/create",
    component: () => import("/vercel/path0/pages/[org_slug]/form/create.vue")
  },
  {
    name: "org_slug-form-observer",
    path: "/:org_slug()/form/observer",
    meta: observerRS5rgp7aIqMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/form/observer.vue")
  },
  {
    name: "org_slug",
    path: "/:org_slug()",
    component: () => import("/vercel/path0/pages/[org_slug]/index.vue")
  },
  {
    name: "org_slug-template-slug-edit",
    path: "/:org_slug()/template/:slug()/edit",
    meta: editkkvh3iHP9fMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/template/[slug]/edit.vue")
  },
  {
    name: "org_slug-template-slug",
    path: "/:org_slug()/template/:slug()",
    component: () => import("/vercel/path0/pages/[org_slug]/template/[slug]/index.vue")
  },
  {
    name: "org_slug-template-slug-preview",
    path: "/:org_slug()/template/:slug()/preview",
    meta: previewmeU5txUS1KMeta || {},
    component: () => import("/vercel/path0/pages/[org_slug]/template/[slug]/preview.vue")
  }
]